import React, { useEffect, useState } from 'react';
import './Footer.styles.scss';
import Viber from '../../assets/images/viber.svg';
import Insta from '../../assets/images/Insta.svg';
import Whatsapp from '../../assets/images/whatsapp.svg';
import FaceBook from '../../assets/images/Facebook.svg';
import VK from '../../assets/images/vk.svg';
import Max from '../../assets/images/max.svg';
import Phone from '../../assets/images/phone.svg';
import Email from '../../assets/images/email.svg';
import logo from '../../assets/images/logo-footer.svg';
import { Logo } from '../../shared/logo/Logo';

const Footer = () => {

    const [currentYear, setCurrentYear] = useState(null);

    useEffect(() => {
        const year = new Date().getFullYear();
        setCurrentYear(year);
    }, []);

    return (
        <footer id='kontakt'>
            <div className='container'>
                <div className='footer__wrapp'>
                    <div className='footer__left'>
                        {/* <img src={logo} alt="логотип" /> */}
                        <Logo variant="white" />
                        <a href='https://psfs.com.pl/' target='__blank' className='footer__psfs-wrapp'>
                            <div className='psfs'>
                                <span>СККР</span>
                            </div>
                            <div className='psfs-text'>
                                <span>Союз клининговых</span>
                                <span>компаний России</span>
                            </div>
                        </a>
                        <div className='footer__copyright'>
                            <span>Тестовый Клининг {currentYear}</span>
                            <span>Все права защищены</span>
                        </div>
                    </div>
                    <div className='footer__right'>
                        <h4>КОНТАКТЫ</h4>
                        <div className='footer__right-wrapp'>
                            <div className='footer__right-center'>
                                <ul className="footer__info">
                                    <li>Клининговая компания Тестовый Клининг, работающая на территории Москвы.</li>
                                    <li>ИНН: 7723456789</li>
                                    <li>ОГРН: 1234567890123</li>
                                    <li>КПП: 772301001</li>
                                </ul>
                                <ul className='footer__info-list'>
                                    <li className="footer__right-item">
                                        <a href='https://alpairya.ru' target='__blank' className="footer__link footer__link-yellow">
                                            Разработка ПО и Приложений - Альперия Софт
                                        </a>
                                    </li>
                                    <li className="footer__right-item">
                                        <a href={"tel:+74951234567"} className="footer__link">
                                            <img src={Phone} alt="Телефон" />
                                            <span>+7 (495) 123-45-67</span>
                                        </a>
                                    </li>
                                    <li className="footer__right-item">
                                        <a href={"mailto:belo.klining@mail.ru"} className="footer__link">
                                            <img src={Email} alt="Email" />
                                            <span>testklining@mail.ru</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <ul className='footer__right-list'>
                                <li className="footer__right-item">
                                    <a href='https://vk.com/belo_klining' target='__blank' className="footer__link">
                                        <img src={VK} alt="ВКонтакте" />
                                    </a>
                                </li>
                                <li className="footer__right-item">
                                    <a href='https://max.ru/belo_klining' target='__blank' className="footer__link">
                                        <img src={Max} alt="МАКС" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* <div className='footer-back-img'></div> */}
                </div>
                <div className='footer__bottom'>
                    ООО «Альперия Софт» (ИНН 6700022427). <br />
                    Наш сайт — это демонстрационный шаблон приложения для клининговых компаний. Сами мы клинингом не занимаемся, поэтому вся информация на сайте носит исключительно тестовый характер.

                </div>
            </div>
        </footer >
    )
}

export default Footer;